(() => {
  const grid = document.getElementById('client-gallery-grid');
  if (!grid) return;

  // ── Collect photo data ──────────────────────────────────────────────────
  const items = Array.from(grid.querySelectorAll('.client-gallery__item'));

  const dataSource = items.map((el) => ({
    src: el.dataset.fullUrl,
    width: parseInt(el.dataset.pswpWidth, 10) || 1600,
    height: parseInt(el.dataset.pswpHeight, 10) || 1067,
  }));

  // ── PhotoSwipe lightbox ─────────────────────────────────────────────────
  let lightbox = null;

  function initLightbox() {
    if (lightbox) return lightbox;

    lightbox = new PhotoSwipeLightbox({
      arrowPrevSVG: '<svg class="pswp__icn" stroke="currentColor" fill="none" viewBox="0 0 30 30"><path d="M17.5 7.5L10 15L17.5 22.5"/></svg>',
      arrowNextSVG: '<svg class="pswp__icn" stroke="currentColor" fill="none" viewBox="0 0 30 30"><path d="M12.5 7.5L20 15L12.5 22.5"/></svg>',
      closeSVG: '<svg class="pswp__icn" stroke="currentColor" fill="none" viewBox="0 0 30 30"><path d="m7.5 22.5 15-15m-15 0 15 15"/></svg>',
      dataSource,
      pswpModule: () => import(window.theme?.settings?.pswpModule || 'https://cdnjs.cloudflare.com/ajax/libs/photoswipe/5.4.3/photoswipe.esm.min.js'),
    });

    lightbox.init();
    return lightbox;
  }

  function openLightbox(index) {
    const lb = initLightbox();
    lb.loadAndOpen(index, dataSource);
  }

  // ── Download single photo ───────────────────────────────────────────────
  async function downloadSingle(url, filename) {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Download failed');
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = objectUrl;
      a.download = filename || 'photo.jpg';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);
    } catch (err) {
      console.error('Download error:', err);
      alert('Could not download this photo. Please try again.');
    }
  }

  // ── Download all as ZIP ─────────────────────────────────────────────────
  async function downloadAll(galleryTitle) {
    if (typeof JSZip === 'undefined') {
      alert('Download tool is still loading, please try again in a moment.');
      return;
    }

    const progressEl = document.getElementById('gallery-progress');
    const progressFill = document.getElementById('gallery-progress-fill');
    const progressText = document.getElementById('gallery-progress-text');
    const downloadAllBtn = document.querySelector('[data-action="download-all"]');

    progressEl.hidden = false;
    if (downloadAllBtn) downloadAllBtn.disabled = true;

    const zip = new JSZip();
    const folder = zip.folder(galleryTitle || 'gallery');
    const total = dataSource.length;
    let completed = 0;

    const updateProgress = (count, message) => {
      const pct = Math.round((count / total) * 100);
      progressFill.style.width = pct + '%';
      progressText.textContent = message || `Downloading ${count} of ${total}...`;
    };

    try {
      // Fetch all photos in parallel (batched to avoid overwhelming the browser)
      const BATCH_SIZE = 5;

      for (let i = 0; i < dataSource.length; i += BATCH_SIZE) {
        const batch = dataSource.slice(i, i + BATCH_SIZE);

        await Promise.all(
          batch.map(async (photo, batchIndex) => {
            const globalIndex = i + batchIndex;
            const filename = `photo-${String(globalIndex + 1).padStart(3, '0')}.jpg`;

            try {
              const response = await fetch(photo.src);
              if (!response.ok) throw new Error(`Failed: ${photo.src}`);
              const blob = await response.blob();
              folder.file(filename, blob);
            } catch (err) {
              console.warn(`Skipping ${filename}:`, err);
            }

            completed++;
            updateProgress(completed);
          })
        );
      }

      updateProgress(total, 'Creating ZIP file...');

      const zipBlob = await zip.generateAsync(
        { type: 'blob', compression: 'STORE' },
        (metadata) => {
          progressFill.style.width = metadata.percent.toFixed(0) + '%';
          progressText.textContent = `Compressing... ${metadata.percent.toFixed(0)}%`;
        }
      );

      const safeTitle = (galleryTitle || 'gallery').replace(/[^a-z0-9]/gi, '-').toLowerCase();
      const objectUrl = URL.createObjectURL(zipBlob);
      const a = document.createElement('a');
      a.href = objectUrl;
      a.download = `${safeTitle}.zip`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);

      progressText.textContent = 'Download complete!';
      setTimeout(() => {
        progressEl.hidden = true;
        progressFill.style.width = '0%';
      }, 3000);
    } catch (err) {
      console.error('ZIP error:', err);
      progressText.textContent = 'Something went wrong. Please try again.';
    } finally {
      if (downloadAllBtn) downloadAllBtn.disabled = false;
    }
  }

  // ── Event delegation ────────────────────────────────────────────────────
  document.addEventListener('click', (e) => {
    const viewBtn = e.target.closest('[data-action="open-lightbox"]');
    if (viewBtn) {
      e.stopPropagation();
      openLightbox(parseInt(viewBtn.dataset.index, 10));
      return;
    }

    const downloadBtn = e.target.closest('[data-action="download-single"]');
    if (downloadBtn) {
      e.stopPropagation();
      downloadSingle(downloadBtn.dataset.url, downloadBtn.dataset.filename);
      return;
    }

    const downloadAllBtn = e.target.closest('[data-action="download-all"]');
    if (downloadAllBtn) {
      downloadAll(downloadAllBtn.dataset.galleryTitle);
      return;
    }

    // Click on photo itself opens lightbox
    const item = e.target.closest('.client-gallery__item');
    if (item) {
      openLightbox(parseInt(item.dataset.index, 10));
    }
  });
})();
